import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {Observable} from 'rxjs';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class LectureService extends BaseService {

    constructor(public http: HttpClient,
                public alertService: AlertService,
                private fileUploadService: UploadService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.LECTURE(), data);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.LECTURE(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.LECTURE(id), data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.LECTURE(id));
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.LECTURE_STATUS(id), data);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }
}
